import React, { FC, useRef, useState, useEffect, createContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { MtsToast } from '@mts-ds/components-react';

const useStyles = makeStyles(() => ({
  root: {
    position: 'fixed',
    bottom: 24,
    right: 24
  }
}));

export const ToastContext = createContext<any>(null);

type IParams = { text: string } & typeof MtsToast.defaultProps;

const Toast: FC = ({ children }) => {
  const classes = useStyles();
  const rootRef = useRef<any>();
  const [toast, setToast] = useState<null | IParams>(null);

  const { text = '', type = 'info', ...props } = (toast || {}) as any;

  useEffect(() => {
    if (!toast) {
      return;
    }

    let cancelled = false;

    // MtsToast отклоняет промисы, если show/hide звать во время анимации
    // («The toast is already visible» / «The toast is showing now») —
    // показываем строго после завершения текущего скрытия и глушим rejection'ы
    const callQuietly = (method: 'show' | 'hide') => {
      try {
        Promise.resolve(rootRef.current?.[method]?.()).catch(() => {});
      } catch {
        // синхронный бросок невозможно, но подстрахуемся
      }
    };

    Promise.resolve(rootRef.current?.hide?.()).catch(() => {}).then(() => {
      if (!cancelled) {
        callQuietly('show');
      }
    });

    const timeout = setTimeout(() => {
      callQuietly('hide');
    }, 10000);

    return () => {
      cancelled = true;
      clearTimeout(timeout);
    };
  }, [toast]);

  return (
    <>
      <ToastContext.Provider value={setToast}>{children}</ToastContext.Provider>
      {
        <MtsToast ref={rootRef} className={classes.root} type={type} {...props}>
          {text}
        </MtsToast>
      }
    </>
  );
};

export default Toast;
